import { Route } from "./Route";

export const PublicRoute = (props) => {
    return <Route render={() => <>{props.children}</>} softphone={false} />;
};
